export default "__VITE_PUBLIC_ASSET__1814df15__"